import { createStyles } from '@mantine/core';
import { Text, Title } from '@repo/foundations';
import type { OnboardingPage } from './constants';

const useStyle = createStyles(() => ({
	title: {
		whiteSpace: 'pre-line',
	},
}));

interface OnboardingViewerContentProps {
	firstName: string;
	workspaceName: string;
	page: OnboardingPage;
}

export default function OnboardingViewerContent({
	firstName,
	workspaceName,
	page,
}: OnboardingViewerContentProps) {
	const { classes } = useStyle();

	const title = page.title(firstName);
	const text = page.text(workspaceName);

	return (
		<>
			<Title order={1} size="xl" className={classes.title}>
				{title}
			</Title>
			<Text>{text}</Text>
		</>
	);
}
